import './App.css';
import vetlindaLogoRedDown from './logo_red_horizontal.png';
import vetLindaLogoRedStand from './vetlinda_logo_red_stand.png';
import vetLindaLogoWhiteDown from './vetlinda_logo_white_down.png';
import bildLinda from './lindaoprio.jpg';
import bildLindaOchPudel from './lindapudel.jpg';
import { useEffect, useState } from 'react';

function App() {
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const isClinicOpen = false; // Ändra till true när mottagningen öppnar igen

  useEffect(() => {
    // Check if user is on thank you page
    if (window.location.pathname === '/tack') {
      setMessage('Tack för din förfrågan! Jag återkopplar så snart som möjligt.');
      setMessageType('success');
    }

    // Handle scroll to show/hide scroll-to-top button
    const handleScroll = () => {
      if (window.pageYOffset > 300) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const form = e.target;
    const data = new FormData(form);
    
    try {
      const response = await fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(data).toString(),
      });
      
      if (response.ok) {
        // Redirect to thank you page
        window.location.href = '/tack';
      } else {
        setMessage('Det uppstod ett fel. Försök igen senare.');
        setMessageType('error');
      }
    } catch (error) {
      setMessage('Det uppstod ett fel. Försök igen senare.');
      setMessageType('error');
    }
  };
  return (
    <div className="App">
      {/* ...existing code... */}
      <header className="vet-header">
        <div className="container">
          <div className="vet-logo">
            <a href="#top" onClick={e => { e.preventDefault(); window.scrollTo({top: 0, behavior: 'smooth'}); }} style={{display: 'inline-block'}}>
              <img src={vetLindaLogoWhiteDown} alt="VetLinda Logo" className="logo-image" />
            </a>
          </div>
          <nav className="vet-nav">
            <a href="#services">Tjänster</a>
            <a href="#prices">Priser</a>
            <a href="#about">Om mig</a>
            <a href="#contact">Kontakt</a>
          </nav>
          <button
            className="hamburger"
            aria-label="Öppna meny"
            aria-expanded={mobileNavOpen}
            onClick={() => setMobileNavOpen((open) => !open)}
          >
            <span className="hamburger-bar"></span>
            <span className="hamburger-bar"></span>
            <span className="hamburger-bar"></span>
          </button>
        </div>
        {mobileNavOpen && (
          <nav className="mobile-nav">
            <a href="#services" onClick={() => setMobileNavOpen(false)}>Tjänster</a>
            <a href="#prices" onClick={() => setMobileNavOpen(false)}>Priser</a>
            <a href="#about" onClick={() => setMobileNavOpen(false)}>Om mig</a>
            <a href="#contact" onClick={() => setMobileNavOpen(false)}>Kontakt</a>
          </nav>
        )}
      </header>

      <main className="vet-main">
        <section className="hero-section">
          <div className="container">
            <div className="hero-content">
              <h2>Välkommen till en liten mottagning med stor omsorg för dig och ditt djur!</h2>
              <p>Smådjursvård med personligt bemötande i lugn miljö på min mottagning hemma i Medle, Skellefteå eller med hembesök hemma hos dig och ditt djur.</p>
              <div className="hero-benefits">
                <div className="benefit">✓ Personligt bemötande i lugn miljö</div>
                <div className="benefit">✓ Mottagning i Medle eller hembesök</div>
                <div className="benefit">✓ Småskalig och personlig veterinärvård</div>
              </div>
              <div className="hero-buttons">
                <a className="btn-primary" href="#contact">Boka tid</a>
              </div>
            </div>
            <div className="hero-image">
              <div className="hero-logo-container">
                  <img src={vetLindaLogoRedStand} alt="VetLinda - Veterinär Linda Lundström" className="hero-logo" />
                </div>
            </div>
          </div>
        </section>

        <section id="about" className="about-section">
          <div className="container">
            <h3>Om mig</h3>
            <div className="about-content">
              <div className="about-text">
                <p>Jag har alltid älskat djur, uppvuxen med hundar i hemmet och tillbringat oräkneliga timmar på den lokala ridskolan som ung. Än idag är hundar mitt största intresse och jag tillbringar all möjlig tid tränandes olika hundsporter med min Border Collie Prio.</p>
                <p>Min stora dröm sedan barnsben har varit att bli veterinär och i januari 2016 tog jag examen från Veterinärprogrammet på SLU i Uppsala. Jag har sedan veterinärexamen arbetat som klinikveterinär på Hälsinge Smådjursklinik där jag arbetat med medicinska utredningar, akutpatienter samt med kirurgi. Särskilt intresserad är jag av sjukdomar som rör gastroenterologi; sjukdomar i djurets mag-tarmkanal.</p>
                <p>Jag är uppvuxen i Norsjö, Västerbottens inland, och när vi väntade vårt andra barn blev hemlängtan för stor och det var dags att flytta hem till Västerbotten igen. Vi flyttade till byn Medle, strax väster om Skellefteå och väl här är det nu dags att förverkliga nästa barndomsdröm; –min egna veterinärmottagning där jag kan ha småskalig och personlig veterinärvård.</p>
              </div>
              <div className="about-image">
                  <img src={bildLinda} alt="Veterinär Linda Lundström" />
              </div>
            </div>
          </div>
        </section>

        <section className="benefits-section">
          <div className="container">
            <h3>Ett stressfritt och tryggt vårdmöte</h3>
            <p>Jag strävar efter ett så lugnt och stressfritt veterinärbesök som möjligt. Min mottagning är mer hemlik för att både du som djurägare och ditt djur ska ha lättare att slappna av. I de fall vi behöver gå vidare med mer omfattande vård såsom operationer och röntgen remitterar jag er till andra veterinärer och kliniker för att säkerställa att era djur får den bästa vården på rätt plats.</p>
          </div>
          <div className="container benefits-image-container">
            <div className="about-image benefits-photo">
              <img src={bildLindaOchPudel} alt="Veterinär Linda Lundström med Pudel" />
            </div>
          </div>
        </section>

        <section id="services" className="services-section">
          <div className="container">
            <h3>Tjänster</h3>
            <p className="services-intro">Jag erbjuder både förebyggande vård och medicinska utredningar. Mitt mål är att kunna erbjuda högkvalitativ vård med ett stort personligt engagemang genom djurets alla faser i livet. Undersökningarna sker i lugn, hemlik miljö med ditt djurs välbefinnande i fokus.</p>
            
            <div className="services-grid">
              <div className="service-card">
                <div className="service-icon">💉</div>
                <h4>Förebyggande vård</h4>
                <p>Vaccinationer, besiktningar och förebyggande behandlingar</p>
              </div>
              <div className="service-card">
                <div className="service-icon">🩹</div>
                <h4>Akuta besvär</h4>
                <p>Mindre sårskador/bölder, klobrott och första bedömningar</p>
              </div>
              <div className="service-card">
                <div className="service-icon">🐕</div>
                <h4>Öroninflammationer</h4>
                <p>Behandling av öroninflammationer, hudsjukdomar och analsäcksinflammationer</p>
              </div>
              <div className="service-card">
                <div className="service-icon">🔬</div>
                <h4>Medicinska utredningar</h4>
                <p>Kroniska sjukdomar, provtagning och laboratorieanalyser</p>
              </div>
              <div className="service-card">
                <div className="service-icon">🔍</div>
                <h4>Knölkoll</h4>
                <p>Undersökning och bedömning av knölar och hudförändringar</p>
              </div>
              <div className="service-card">
                <div className="service-icon">🏥</div>
                <h4>Remisser</h4>
                <p>Hjälp med remittering till rätt klinik för avancerad diagnostik eller kirurgi</p>
              </div>
            </div>
            
            <div className="specialization">
            {/* Specialization section removed as per feedback */}
            </div>
          </div>
        </section>

        <section id="prices" className="prices-section">
          <div className="container">
            <h3>Priser</h3>
            <p className="prices-intro">Priser för några av de vanligaste tjänsterna ses nedan. Har du funderingar över andra priser så kontakta mig.</p>
            
            <div className="pricing-tables">
              <div className="pricing-table">
                <h4>Veterinärbesök & Tillägg</h4>
                <div className="price-items">
                  <div className="price-item">
                    <div className="price-service">
                      <span>Veterinärbesök*</span>
                      <small>*därefter tillkommer kostnad för behandlingar, provtagningar, specifika undersökningar etc.</small>
                    </div>
                    <div className="price-amount">800 kr</div>
                  </div>
                  <div className="price-item">
                    <div className="price-service">
                      <span>Kvälls- och helgtillägg:</span>
                      <small>I förväg bokade besök för vardagar efter kl 17.00 samt helger och röda dagar.</small>
                    </div>
                    <div className="price-amount">500 kr</div>
                  </div>
                  <div className="price-item">
                    <div className="price-service">
                      <span>Jourtillägg kväll- och helg:</span>
                      <small>Akutbesök vardagar efter kl 17.00, samt helger och röda dagar.</small>
                    </div>
                    <div className="price-amount">1200 kr</div>
                  </div>
                </div>
              </div>

              <div className="pricing-table">
                <h4>Vaccinationer & Besiktningar</h4>
                <div className="price-items">
                  <div className="price-item">
                    <div className="price-service">Vaccination inkl rabies (ej herpes)</div>
                    <div className="price-amount">495 kr</div>
                  </div>
                  <div className="price-item">
                    <div className="price-service">Besiktning, ID-chip & vaccination valp KULL</div>
                    <div className="price-amount">875 kr</div>
                  </div>
                  <div className="price-item">
                    <div className="price-service">Besiktning, ID-chip & 2 vaccinationer kattunge KULL</div>
                    <div className="price-amount">990 kr</div>
                  </div>
                  <div className="price-item">
                    <div className="price-service">Besiktning vuxet djur</div>
                    <div className="price-amount">975 kr</div>
                  </div>
                </div>
              </div>

              <div className="pricing-table">
                <h4>Övriga Tjänster</h4>
                <div className="price-items">
                  <div className="price-item">
                    <div className="price-service">
                      <span>Kastration hankatt (med båda testiklar i pungen)</span>
                      <small>Vaccination och ID-chip 30% rabatt i samband med kastration</small>
                    </div>
                    <div className="price-amount">900 kr</div>
                  </div>
                  <div className="price-item">
                    <div className="price-service">
                      <span>Kemisk kastrering hanhund 6 mån</span>
                    </div>
                    <div className="price-amount">2595 kr</div>
                  </div>
                  <div className="price-item">
                    <div className="price-service">Pass</div>
                    <div className="price-amount">700 kr</div>
                  </div>
                  <div className="price-item">
                    <div className="price-service">Pass + rabiesvaccination</div>
                    <div className="price-amount">1150 kr</div>
                  </div>
                  <div className="price-item">
                    <div className="price-service">Avmaskningsintyg (exkl. medicin)</div>
                    <div className="price-amount">275 kr</div>
                  </div>
                  <div className="price-item">
                    <div className="price-service">Pälsvård katt under sedering</div>
                    <div className="price-amount">1795 kr</div>
                  </div>
                  <div className="price-item">
                    <div className="price-service">Kloklippning m. sedering</div>
                    <div className="price-amount">800 kr</div>
                  </div>
                  <div className="price-item">
                    <div className="price-service">ID-märkning</div>
                    <div className="price-amount">375 kr</div>
                  </div>
                </div>
              </div>

              <div className="pricing-table">
                <h4>Avlivning</h4>
                <div className="price-items">
                  <div className="price-item">
                    <div className="price-service">
                      <span>Avlivning hund</span>
                    </div>
                    <div className="price-amount">1575 kr</div>
                  </div>
                  <div className="price-item">
                    <div className="price-service">
                      <span>Avlivning hund med allmän kremering</span>
                    </div>
                    <div className="price-amount">3200 kr</div>
                  </div>
                  <div className="price-item">
                    <div className="price-service">
                      <span>Avlivning hund med separat kremering</span>
                      <small>Ev träurna tillkommer med 300 kr</small>
                    </div>
                    <div className="price-amount">4200 kr</div>
                  </div>
                  <div className="price-item">
                    <div className="price-service">
                      <span>Avlivning katt</span>
                    </div>
                    <div className="price-amount">1300 kr</div>
                  </div>
                  <div className="price-item">
                    <div className="price-service">
                      <span>Avlivning katt med allmän kremering</span>
                    </div>
                    <div className="price-amount">2480 kr</div>
                  </div>
                  <div className="price-item">
                    <div className="price-service">
                      <span>Avlivning katt med separat kremering</span>
                      <small>Ev träurna tillkommer med 300 kr</small>
                    </div>
                    <div className="price-amount">3480 kr</div>
                  </div>
                </div>
                <p style={{marginTop: '1rem', fontSize: '0.95rem', lineHeight: '1.6'}}>
                  Efter avlivning får ni välja att ta med djuret hem eller lämna kroppen hos mig. Jag samarbetar med <a href="https://djurvilan.nu" target="_blank" rel="noopener noreferrer" style={{color: '#a64035', textDecoration: 'underline'}}>Djurvilan</a> i Raggvaldsträsk som erbjuder djurbegravning och asklund samt Concremo i Sävar som erbjuder kremering.
                </p>
              </div>
            </div>

            <div className="home-visit-info">
              <h4>Hembesök</h4>
              <p>Vid hembesök tillkommer en fast inställelseavgift på <strong>650 kr</strong> + resekostnad på <strong>10 kr /km</strong> (utgående från Medlevägen 218) för resor &lt;50 km. Kilometrar &gt; 50 km debiteras med <strong>15 kr/km</strong>.</p>
            </div>

            <div className="swish-info" style={{marginTop: '2rem', textAlign: 'center'}}>
              <p><strong>Betalning sker med Swish i samband med besöket till 1231894880.</strong></p>
            </div>
            <div className="price-disclaimer">
              <p><em>Jag reserverar mig för eventuella prisjusteringar och tryckfel i publicerad prislista.</em></p>
            </div>
          </div>
        </section>

        <section id="contact" className="contact-section">
          <div className="container">
            <h3>Boka tid</h3>

            {!isClinicOpen && (
              <div className="clinic-closed-notice" style={{
                background: '#fff3cd',
                border: '2px solid #ffc107',
                borderRadius: '8px',
                padding: '1.5rem',
                marginBottom: '2rem',
                textAlign: 'center'
              }}>
                <h4 style={{color: '#856404', marginTop: 0, marginBottom: '0.5rem'}}>⚠️ Mottagningen är tillfälligt stängd</h4>
                <p style={{color: '#856404', margin: 0, fontSize: '1rem', lineHeight: '1.6'}}>
                  Mottagningen är tyvärr stängd under november eftersom jag själv ska opereras. Jag uppdaterar sociala medier och hemsidan när jag åter har öppet och ni kan boka besök igen.
                </p>
              </div>
            )}

            <div className="contact-content">
              <div className="contact-info">
                <p>Enklast bokar ni tid genom att kontakta mig via mail eller SMS så återkopplar jag så snart som möjligt. Jag försöker svara på förfrågningar inom 1-3 arbetsdagar. Har ni ej fått svar så kontrollera er skräppostmapp då en del svarsmail tyvärr verkar hamna där.</p>
                <p>Ni kan även ringa, svarar jag ej så skicka ett SMS så ringer jag upp så snart jag kan.</p>
                
                <h4>Vid bokningsförfrågan uppge följande:</h4>
                <ul className="booking-requirements">
                  <li>För- och Efternamn</li>
                  <li>Fullständig adress (Medlevägen 218, Skellefteå)</li>
                  <li>Telefonnummer</li>
                  <li>Namn, födelsedatum, art, ras och kön på det djur ni önskar boka tid för</li>
                  <li>Vad bokningen gäller (vaccin, veterinärbesök, besiktning etc.)</li>
                  <li>Önskemål på dagar/tider (tider bokas i första hand vardagar mellan 9-15)</li>
                </ul>
                
                <div className="contact-details">
                  <div className="contact-item">
                    <span>📞</span>
                    <a href="tel:+46722118027">072-2118027</a>
                  </div>
                  <div className="contact-item">
                    <span>📧</span>
                    <a href="mailto:linda@vetlinda.se">linda@vetlinda.se</a>
                  </div>
                  <div className="contact-item">
                    <span>📍</span>
                    <span>Medlevägen 218, Skellefteå</span>
                  </div>
                </div>
              </div>
              <div className="booking-form" style={{position: 'relative', display: isClinicOpen ? 'block' : 'none'}}>
                {!isClinicOpen && (
                  <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'rgba(255, 255, 255, 0.95)',
                    backdropFilter: 'blur(3px)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '8px',
                    zIndex: 10,
                    padding: '2rem'
                  }}>
                    <div style={{
                      textAlign: 'center',
                      maxWidth: '400px'
                    }}>
                      <div style={{fontSize: '3rem', marginBottom: '1rem'}}>🔒</div>
                      <h4 style={{color: '#6c757d', marginBottom: '0.5rem', fontSize: '1.25rem'}}>
                        Bokningar är tillfälligt stängda
                      </h4>
                      <p style={{color: '#868e96', fontSize: '0.95rem', lineHeight: '1.5'}}>
                        Formuläret blir tillgängligt igen när mottagningen öppnar.
                      </p>
                    </div>
                  </div>
                )}
                {message && (
                  <div className={`form-message ${messageType}`}>
                    {message}
                  </div>
                )}
                <form name="booking" method="POST" data-netlify="true" netlify-honeypot="bot-field" onSubmit={handleSubmit} style={{opacity: isClinicOpen ? 1 : 0.4}}>
                  <input type="hidden" name="form-name" value="booking" />
                  <p hidden>
                    <label>Don't fill this out: <input name="bot-field" /></label>
                  </p>
                  <input type="text" name="owner_name" placeholder="För- och Efternamn *" required disabled={!isClinicOpen} />
                  <input type="tel" name="phone" placeholder="Telefonnummer *" required disabled={!isClinicOpen} />
                  <input type="email" name="email" placeholder="E-post *" required disabled={!isClinicOpen} />
                  <input type="text" name="address" placeholder="Adress (med postnummer) *" required disabled={!isClinicOpen} />
                  <input type="text" name="pet_name" placeholder="Djurets namn *" required disabled={!isClinicOpen} />
                  <div className="form-row">
                    <select name="pet_species" required disabled={!isClinicOpen}>
                      <option value="">Välj djurart *</option>
                      <option value="hund">Hund</option>
                      <option value="katt">Katt</option>
                      <option value="kanin">Kanin</option>
                      <option value="gnagare">Gnagare</option>
                      <option value="fågel">Fågel</option>
                      <option value="reptil">Reptil</option>
                      <option value="annat">Annat</option>
                    </select>
                    <select name="pet_gender" required disabled={!isClinicOpen}>
                      <option value="">Välj kön *</option>
                      <option value="hane">Hane</option>
                      <option value="hona">Hona</option>
                      <option value="kastrerad_hane">Kastrerad hane</option>
                      <option value="kastrerad_hona">Kastrerad hona</option>
                    </select>
                  </div>
                  <input type="text" name="pet_breed" placeholder="Ras (t.ex. Golden Retriever, Perser) *" required disabled={!isClinicOpen} />
                  <input type="text" name="pet_birthdate" placeholder="Djurets födelsedatum (t.ex. 2020-05-14)" disabled={!isClinicOpen} />
                  <textarea name="booking_details" placeholder="Vad gäller bokningen? Beskriv kort problemet eller ange tjänst (vaccin, besiktning etc.) *" rows="4" required disabled={!isClinicOpen}></textarea>
                  <textarea name="preferred_times" placeholder="Önskade tider (dagtid, kväll, helg) *" rows="2" required disabled={!isClinicOpen}></textarea>
                  <div className="form-group gdpr-group">
                    <label className="gdpr-label">
                      <input type="checkbox" name="gdpr_consent" required className="gdpr-checkbox" disabled={!isClinicOpen} />
                      <span>
                        Jag godkänner att mina personuppgifter behandlas enligt
                        <span> </span><a href="#privacy-policy" className="gdpr-link">integritetspolicyn</a>.
                      </span>
                    </label>
                  </div>
                  <button type="submit" className="btn-primary" disabled={!isClinicOpen}>Skicka förfrågan</button>
                </form>
              </div>
            </div>
          </div>
        </section>

        <section id="privacy-policy" className="privacy-policy-section" style={{background: '#faf6f2', padding: '3rem 0', marginTop: '2rem'}}>
          <div className="container">
            <h3>Integritetspolicy</h3>
            <p>
              Din integritet är viktig för oss. När du skickar in en bokningsförfrågan via detta formulär samlar jag in de personuppgifter du anger (namn, kontaktuppgifter, information om ditt djur och bokningsdetaljer) för att kunna hantera din förfrågan och kontakta dig vid behov. Uppgifterna lagras säkert och delas inte med tredje part utanför vad som krävs för att fullfölja din bokning eller enligt lag. Du har rätt att begära tillgång till, rättelse eller radering av dina personuppgifter. Kontakta mig på linda@vetlinda.se för frågor om dataskydd.
            </p>
          </div>
        </section>
      </main>

      <footer className="vet-footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-left">
              <div className="vet-logo">
                <img src={vetlindaLogoRedDown} alt="VetLinda Logo" style={{height:'120px', width:'auto'}} />
              </div>
            </div>
            <div className="footer-right">
              <h4>Kontakt</h4>
              <p>Tel: <a href="tel:+46722118027">072-2118027</a></p>
              <p>Email: <a href="mailto:linda@vetlinda.se">linda@vetlinda.se</a></p>
              <p>Adress: Medlevägen 218, Skellefteå</p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2026 Veterinär Linda Lundström.</p>
          </div>
        </div>
      </footer>

      {/* Scroll to Top Button */}
      {showScrollTop && (
        <button 
          className="scroll-to-top" 
          onClick={scrollToTop}
          aria-label="Scroll to top"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <polyline points="18,15 12,9 6,15"></polyline>
          </svg>
        </button>
      )}
    </div>
  );
}

export default App;
